export const PROJET_LIST = {
    ADD_ITEMS: 'ADD_SITE_LIST_ITEMS',
    SET_ITEMS : 'SET_SITE_LIST_ITEMS',
    SET_SCROLL : 'SET_SITE_LIST_SCROLL',
    SET_PAGE : 'SET_SITE_LIST_PAGE',
    SET_PAGES : 'SET_SITE_LIST_PAGES',
    SET_LOADING : 'SET_SITE_LIST_LOADING',
    SET_ERROR : 'SET_SITE_LIST_ERROR',
    SET_FILTER: 'SET_FILTER',
    SET_SELECTED: 'SET_SELECTED',
    RESET: 'SITE_LIST_RESET',
    SET_SITE_ID: 'SET_SITE_ID',
    RESET_FILTER: 'RESET_FILTER'
};
